import { Component, Inject, EventEmitter, Input, Output } from "@angular/core";

import { Observable, Subject } from 'rxjs';
import { SubjectRelay } from "../../../../shared/commands/subject-relay.class";

import { MatTableDataSource } from "@angular/material/table";

import { LocalDate } from "../../../../shared/jsr310-localdates/types/local-date.type";

import { IntervenantEntity } from "../../../humain/intervenant/entities/intervenant.entity";
import { EntrepriseTLR } from "../../../entreprises/entities/entreprise-tlr.entity";

import { NouveauRisqueEntity } from "../../entities/nouveau-risque.entity";
import { PlanPreventionEntity } from "../../entities/plan-prevention.entity";
import { ValidateurEntity } from "../../entities/validateur.entity";
import { SignatairePdpEntity } from "../../entities/signataire-pdp.entity";
import { TypeValideur, ValideurSignataireEntity } from "../../entities/valideur-signataire.entity";

import { PlanPreventionService } from "../../services/plan-prevention.service";
import { IntervenantService } from "../../../humain/intervenant/services/intervenant.service";

import { StepFinalModel } from "../../entities/step-final-model.entity";

import { applicationConstants } from "../../../../app.constants";
import { EntrepriseExterieureEntity } from "../../entities/entreprise-exterieure.entity";
import { RepresentantEntity } from "../../entities/representant.entity";

@Component({
	selector: 'finalisation-pdp',
	templateUrl: 'finalisation-pdp.html',
	styleUrls: ['finalisation-pdp.css']
})
export class FinalisationPdpComponent {

	planPrevention!: PlanPreventionEntity;
	dateInspectionCommunePrealable!: LocalDate | null;

	/* Validation du plan de prévention */
	idValideur: number = 0;
	nomPrenomValidateur!: string;
	fonction!: string;
	dateValidation!: number[] | null;
	signature!: string;
	valideurs: ValidateurEntity[] = [];
	valideurSignataires: ValideurSignataireEntity[] = [];
	selectedEntrepriseIds: number[] = [];
	selectedValideurs: SignatairePdpEntity[] = [];

	/* SURVENANCE DE NOUVEAU(X) RISQUE(S) */
	nouveauxRisques: MatTableDataSource<NouveauRisqueEntity> = new MatTableDataSource<NouveauRisqueEntity>();
	idNouveauRisque: number = 0;
	dateApparitionNouveauRisque!: number[] | null;
	causeApparition!: string;
	entreprisesConcernees!: string;
	nouveauRisqueIdentifie!: string;
	mesurePreventionProtection!: string;
	eu!: boolean;
	ee!: boolean;
	getEntrepriseLabel = (entreprise: EntrepriseTLR) => entreprise.nom;
	getIntervenantLabel = (intervenant: SignatairePdpEntity) => (intervenant.prenom ? intervenant.prenom + ' ' : '')  + intervenant.nom;
	validateurKeyGetter = (intervenant: SignatairePdpEntity | null) => intervenant ? intervenant.id : null;
	getSelectedValideurSignataire = (valideur: SignatairePdpEntity) => {
		let v = this.valideurSignataires.find( $ => $.id === valideur.id );
		if (v) {
			return v.id;
		} else {
			return null;
		}
	};
	displayedColumnsNouveauxRisques: string[] = ['dateApparitionNouveauRisque', 'causeApparition', 'entreprisesConcernees', 'raisonSociale', 
		'nouveauRisqueIdentifie', 'mesurePreventionProtection', 'eu', 'ee', 'nomsMesurePrevention', 'trashMesurePrevention'];

	/* Tableau d'émargement */
	signataires: MatTableDataSource<SignatairePdpEntity> = new MatTableDataSource<SignatairePdpEntity>();
	displayedColumnsSignataires: string[] = ['nom', 'prenom', 'entreprise', 'raisonSociale', 'email', 'fonction'];

	representants: MatTableDataSource<SignatairePdpEntity> = new MatTableDataSource<SignatairePdpEntity>();
	displayedColumnsRepresentants: string[] = ['nom', 'prenom', 'entreprise', 'raisonSociale', 'email', 'isIntervenant', 'fonction'];
	
	gererRepresentantsCommands = new Subject<[SignatairePdpEntity[], SignatairePdpEntity[]]>();
	gererIntervenantsCommands = new Subject<[SignatairePdpEntity[], SignatairePdpEntity[]]>();
	
	selectedEntrepriseForRepresentantDialog!: EntrepriseTLR | null;
	selectedEntrepriseForIntervenantDialog!: EntrepriseTLR | null;
	
	isUpdateMode: boolean = false;
	isDuplicateMode: boolean = false;
	versionTechnique!: number;
	typePdp!: number;
	idPdp!: number;
	pdpToCopyId: number = -1;

	entrepriseUtilisatrice!: EntrepriseTLR;
	entreprises: EntrepriseTLR[] = [];
	personnesPouvantSigner: SignatairePdpEntity[] = [];
	personnesPouvantSignerDansEntrepriseUtilisatrice: SignatairePdpEntity[] = [];
	displayableSignataires: SignatairePdpEntity[][] = [];
	entreprisesValideurs: EntrepriseTLR[] = [];
	entreprisesExterieures: Map<number, EntrepriseExterieureEntity> = new Map<number, EntrepriseExterieureEntity>();

	// Liaison de l'observable servant a commander l'affichage du composant
	private planPreventionCommandsSubject = new SubjectRelay<PlanPreventionEntity>();
	@Input() set planPreventionCommands(obs: Observable<PlanPreventionEntity> | undefined) {
		this.planPreventionCommandsSubject.registerSource(obs);
	}

	private entreprisesPouvantSignerCommandSubject = new SubjectRelay<EntrepriseTLR[]>();
	@Input() set entreprisesPouvantSignerCommands(obs: Observable<EntrepriseTLR[]> | undefined) {
		this.entreprisesPouvantSignerCommandSubject.registerSource(obs);
	}

	private entrepriseUtilisatriceCommandSubject = new SubjectRelay<EntrepriseTLR>();
	@Input() set entrepriseUtilisatriceCommands(obs: Observable<EntrepriseTLR> | undefined) {
		this.entrepriseUtilisatriceCommandSubject.registerSource(obs);
	}

	private typePdpCommandSubject = new SubjectRelay<number>();
	@Input() set typePdpCommands(obs: Observable<number> | undefined) {
		this.typePdpCommandSubject.registerSource(obs);
	}
	
	private idPdpCommandSubject = new SubjectRelay<number>();
	@Input() set idPdpCommands(obs: Observable<number> | undefined) {
		this.idPdpCommandSubject.registerSource(obs);
	}

	private versionPdpCommandsSubject = new SubjectRelay<number>();
	@Input() set versionPdpCommands(obs: Observable<number> | undefined) {
		this.versionPdpCommandsSubject.registerSource(obs);
	}

	@Input() mandatoryField: boolean = false;
	
	@Output() onModelChange = new EventEmitter<StepFinalModel>();
	
	typeValideurs = applicationConstants.typeValideurs;	
	
	private pdpToCopySubject = new SubjectRelay<number>();
	@Input() set pdpToCopy(obs: Observable<number>) {
		this.pdpToCopySubject.registerSource(obs);
	}
	
	constructor(
		@Inject(PlanPreventionService) private planPreventionService: PlanPreventionService,
		@Inject(IntervenantService) private intervenantService: IntervenantService
	) {
		this.planPreventionCommandsSubject.subscribe(
			(pdp: PlanPreventionEntity) => {
				this.entreprises = [];
				this.personnesPouvantSigner = [];
				this.personnesPouvantSignerDansEntrepriseUtilisatrice = [];
				this.entreprisesValideurs = [];
				this.selectedEntrepriseForRepresentantDialog = null;
				this.selectedEntrepriseForIntervenantDialog = null;
				this.displayableSignataires = [];
				// lors de la reception d'une demande d'affichage
				this.planPrevention = pdp;
				this.getPdpMode();
				this.versionTechnique = pdp.versionTechnique;
				if (pdp.dateInspectionCommunePrealable != null && pdp.dateInspectionCommunePrealable.length === 3) {
					let localDate = [pdp.dateInspectionCommunePrealable[0], pdp.dateInspectionCommunePrealable[1], pdp.dateInspectionCommunePrealable[2]] as LocalDate;
					this.dateInspectionCommunePrealable = localDate;
				}
				this.notifyModelChange();
			}
		);
		this.entrepriseUtilisatriceCommandSubject.subscribe(
			(entrepriseUtilisatrice: EntrepriseTLR) => {
				console.log('entrepriseUtilisatrice: ', entrepriseUtilisatrice);
				this.entrepriseUtilisatrice = entrepriseUtilisatrice;
				this.loadPersonnesPouvantSignerDansEntrepriseUtilisatrice();
				if (!this.entreprisesValideurs.some( $ => $.id === entrepriseUtilisatrice.id)) {
					this.entreprisesValideurs.unshift(entrepriseUtilisatrice);
				}
				// evo 66537 : donner la possibilité d'ajouter l'EU aux entrepriss représentants
				this.entreprises.push(entrepriseUtilisatrice);
				this.entreprises.sort( (e1, e2) => e1.nom.localeCompare(e2.nom) );
				this.notifyModelChange();
			}
		);
		this.entreprisesPouvantSignerCommandSubject.subscribe(
			(entreprisesPouvantSigner: EntrepriseTLR[]) => {
				// recuperation d'une liste d'entreprises pouvant signer ce PDP
				console.log('entreprisesPouvantSigner: ', entreprisesPouvantSigner);
				entreprisesPouvantSigner.forEach( e => {
					if (!this.entreprises.some( $ => $.id === e.id)) {
						this.entreprises.push(e);
					}
					if (!this.entreprisesValideurs.some( $ => $.id === e.id)) {
						this.entreprisesValideurs.push(e);
					}
				} );
				this.entreprises.sort( (e1, e2) => e1.nom.localeCompare(e2.nom) );
				this.entreprisesValideurs.sort( (e1, e2) => e1.nom.localeCompare(e2.nom) );
				this.loadPersonnesPouvantSigner();
				this.loadRisques();
				this.loadTravaux();
			}
		);
		this.typePdpCommandSubject.subscribe(
			(typePdp: number) => {
				console.log('typePdp: ', typePdp);
				this.typePdp = typePdp;
			}
		);
		this.idPdpCommandSubject.subscribe(
			(idPdp: number) => {
				console.log('idPdp: ', idPdp);
				this.idPdp = idPdp;
			}
		);
		this.versionPdpCommandsSubject.subscribe(
			(versionTechnique: number) => {
				console.log('versionTechnique: ', versionTechnique);
				this.versionTechnique = versionTechnique;
			}
		);
		this.pdpToCopySubject.subscribe(
			// lors de la reception d'une demande de duplication
			(pdpToCopyId: number) => {
				this.pdpToCopyId = pdpToCopyId;
			}
		);
	}

	loadPersonnesPouvantSignerDansEntrepriseUtilisatrice() {
		if (this.entrepriseUtilisatrice && this.entrepriseUtilisatrice.id) {
			this.intervenantService.getIntervenantsForEntreprise([this.entrepriseUtilisatrice.id]).subscribe(
				(personnesPouvantSignerDansCetteEntreprise: IntervenantEntity[]) => {
					personnesPouvantSignerDansCetteEntreprise.forEach( personne => {
						if (!this.personnesPouvantSignerDansEntrepriseUtilisatrice.some($ => personne.id === $.id)) {
							this.personnesPouvantSignerDansEntrepriseUtilisatrice.push({
								id: personne.id,
								nom: personne.nom,
								prenom: personne.prenom,
								nomEntreprise: personne.nomEntreprise,
								raisonSociale: this.entrepriseUtilisatrice.raisonSociale,
								idEntreprise: personne.idEntreprise,
								fonction: personne.cadreEmploi,
								hasSigned: false,
								hasSignedEnvelope: false,
								email: personne.email,
								sentToDocusign: false,
								emailStyle: '',
								envelopeId: '',
								envelopeIndex: -1,
								nature: 'intervenant',
								isIntervenant: false,
								updatable: true,
								docusignRecipientId: ''
							});
						}
					} );
					this.loadValideurs();
				}
			);			
		}
	}
	
	loadPersonnesPouvantSigner() {
		let entrepriseIds = this.entreprises.map ( $ => $.id );
		if (entrepriseIds.length > 0) {
			this.intervenantService.getIntervenantsForEntreprise(entrepriseIds).subscribe(
				(personnesPouvantSignerDansCetteEntreprise: IntervenantEntity[]) => {
					personnesPouvantSignerDansCetteEntreprise.forEach(personne => {
						let entreprise = this.entreprises.find($ => $.id === personne.idEntreprise);
						if (!this.personnesPouvantSigner.some($ => personne.id === $.id)) {
							this.personnesPouvantSigner.push({
								id: personne.id,
								nom: personne.nom,
								prenom: personne.prenom,
								nomEntreprise: personne.nomEntreprise,
								raisonSociale: entreprise ? entreprise.raisonSociale : '',
								idEntreprise: personne.idEntreprise,
								fonction: personne.cadreEmploi,
								hasSigned: false,
								hasSignedEnvelope: false,
								email: personne.email,
								sentToDocusign: false,
								emailStyle: '',
								envelopeId: '',
								envelopeIndex: -1,
								nature: 'intervenant',
								isIntervenant: false,
								updatable: true,
								docusignRecipientId: ''
							});
						}
					});
					this.loadValideurs();
				}
			);			
		}
	}
	
	loadSignataires() {
		let pdpRefId = this.isDuplicateMode ? this.pdpToCopyId : this.planPrevention.id;
		if (pdpRefId && pdpRefId != -1) {
			this.planPreventionService.getIntervenants(pdpRefId).subscribe(
		        (data: PlanPreventionEntity) => {
					if (data.signataires != null) {
						let pdpEntrepriseIds = this.entreprises.concat(this.entrepriseUtilisatrice).map( $ => $.id );
						let newSource: SignatairePdpEntity[] = [];
						data.signataires.forEach((value: SignatairePdpEntity) => {
							if (pdpEntrepriseIds.indexOf(value.idEntreprise) > -1 && value.nature === 'intervenant') {
								let raisonSociale = this.extractRaisonSociale(
									data.entreprisesExterieures, 
									value.idEntreprise, 
									value.nomEntreprise ? value.nomEntreprise : ''
								);
								newSource.push({
									id: value.id,
									nom: value.nom,
									prenom: value.prenom,
									nomEntreprise: value.nomEntreprise,
									raisonSociale: raisonSociale, 
									idEntreprise: value.idEntreprise,
									fonction: value.fonction,
									hasSigned: this.isDuplicateMode ? false : value.hasSigned,
									hasSignedEnvelope: this.isDuplicateMode ? false : value.hasSignedEnvelope,
									email: value.email,
									sentToDocusign: this.isDuplicateMode ? false : value.sentToDocusign,
									emailStyle: '',
									envelopeId: this.isDuplicateMode ? '' : value.envelopeId,
									envelopeIndex: value.envelopeIndex,
									nature: value.nature,
									isIntervenant: true,
									updatable: true,
									docusignRecipientId: ''
								});
							}
						});
						this.signataires = new MatTableDataSource<SignatairePdpEntity>(newSource);
						if (this.valideurSignatairesApplicable()) {
							this.planPreventionService.getValideursEtRepresentants(pdpRefId).subscribe(
						        (data: PlanPreventionEntity) => {
									if (data.valideurSignataires != null) {
										this.addExistingValideurSignataires(data);
									}
									if (data.representants != null) {
										this.addExistingRepresentants(data);
									}
									this.notifyModelChange();
								}
							);
						} else {
							this.planPreventionService.getValideurs(pdpRefId).subscribe(
						        (data: PlanPreventionEntity) => {
									if (data.valideurs != null) {
										this.addExistingValideurs(data);
									}
									this.notifyModelChange();
								}
							);
						}
					}
					this.notifyModelChange();
				}
			);
		}
	}
	
	loadRisques() {
		let pdpRefId = this.isDuplicateMode ? this.pdpToCopyId : this.planPrevention.id;
		if (pdpRefId && pdpRefId != -1) {
			this.planPreventionService.getNouveauxRisques(pdpRefId).subscribe(
				(data: PlanPreventionEntity) => {
					if (data.nouveauxRisques != null) {
						this.addExistingRisques(data);
					}
					this.notifyModelChange();
				}
			);
		}
	}
	
	loadTravaux() {
		let pdpRefId = this.isDuplicateMode ? this.pdpToCopyId : this.planPrevention.id;
		this.entreprisesExterieures = new Map<number, EntrepriseExterieureEntity>();
		if (pdpRefId && pdpRefId != -1) {
			this.planPreventionService.getTravaux(pdpRefId).subscribe(
				(data: PlanPreventionEntity) => {
					if (this.entrepriseUtilisatrice) {
						this.entrepriseUtilisatrice.raisonSociale = data.raisonSociale;
					}
					if (data.entreprisesExterieures != null) {
						data.entreprisesExterieures.forEach( ee => {
							this.entreprisesExterieures.set(ee.idEntrepriseExt, ee);
						} );
					}
				}
			);
		}
	}
	
	addExistingRisques(planPrevention: PlanPreventionEntity) {
		this.idNouveauRisque = 0;
		let newSource: NouveauRisqueEntity[] = [];
		planPrevention.nouveauxRisques.forEach( $ => {
			$.id = ++this.idNouveauRisque;
			$.updatable = true;
			newSource.push($);
			this.initListeEntreprisesTableauRisque($, this.entreprises);
			$.entreprisesConcernees.forEach( entrepriseConcernee => {
				$.entreprisesSelected.set(entrepriseConcernee.id, true);
				this.updateAvailableEnteprises($);
				let raisonSociale = this.extractRaisonSociale(
					planPrevention.entreprisesExterieures, 
					entrepriseConcernee.id, 
					entrepriseConcernee.nom ? entrepriseConcernee.nom : ''
				);
				entrepriseConcernee.raisonSociale = raisonSociale;
				$.selectedEntreprises.push({ entreprise: entrepriseConcernee });
			} );
		});
		this.nouveauxRisques = new MatTableDataSource<NouveauRisqueEntity>(newSource);
	}
	
	loadValideurs() {
		this.valideurSignataires = [];
		this.valideurs.splice(0, this.valideurs.length);
		
		this.loadSignataires();
	}

	addExistingValideurs(planPrevention: PlanPreventionEntity) {
		this.idValideur = 0;
		this.selectedEntrepriseIds = [];
		this.valideurs.splice(0, this.valideurs.length);
		planPrevention.valideurs.forEach( $ => {
			$.id = ++this.idValideur;
			$.raisonSociale = this.extractRaisonSociale(
				planPrevention.entreprisesExterieures, 
				$.entrepriseValidateur.id,
				$.entrepriseValidateur.nom
			);
			this.valideurs.push($);
			this.selectedEntrepriseIds.push($.entrepriseValidateur.id);
		});
	}
	
	addExistingValideurSignataires(planPrevention: PlanPreventionEntity) {
		this.idValideur = 0; // raz compteur de lignes
		this.selectedEntrepriseIds = []; // raz this.selectedEntrepriseIds
		this.selectedValideurs.splice(0, this.selectedValideurs.length); // raz this.selectedValideurs
		this.valideurSignataires.splice(0, this.valideurSignataires.length); // raz this.valideurSignataires
		this.displayableSignataires = []; // raz this.displayableSignataires
		planPrevention.valideurSignataires.forEach( $ => {
			$.id = ++this.idValideur;
			$.raisonSociale = this.extractRaisonSociale(
				planPrevention.entreprisesExterieures, 
				$.intervenantEntrepriseId, 
				$.intervenantEntrepriseNom ? $.intervenantEntrepriseNom : ''
			);
			this.valideurSignataires.push($);
			this.selectedEntrepriseIds.push($.intervenantEntrepriseId);
			let signataire = this.allPersonsPouvantSigner().find(sig => sig.id === $.intervenantId);
			if (signataire) {
				this.selectedValideurs.push(signataire);
			};
			this.displayableSignataires.push([ ... this.allPersonsPouvantSigner() ]);
			// moins tous ceux qui sont précédemment selectionnés
			let chosenIntervnants = this.valideurSignataires.map( $ => $.intervenantId );
			this.displayableSignataires[this.displayableSignataires.length - 1] = this.displayableSignataires[this.displayableSignataires.length - 1].filter($ => chosenIntervnants.indexOf($.id) === -1);
		} );
	}

	addExistingRepresentants(planPrevention: PlanPreventionEntity) {
		if (planPrevention.representants != null) {
			let pdpEntrepriseIds = this.entreprises.concat(this.entrepriseUtilisatrice).map( $ => $.id );
			let newSource: SignatairePdpEntity[] = [];
			planPrevention.representants.forEach((value: RepresentantEntity) => {
				if (pdpEntrepriseIds.indexOf(value.intervenantEntrepriseId) > -1) {
					let raisonSociale = this.extractRaisonSociale(
						planPrevention.entreprisesExterieures, 
						value.intervenantEntrepriseId, 
						value.intervenantEntrepriseNom ? value.intervenantEntrepriseNom : ''
					);
					newSource.push({
						id: value.intervenantId,
						nom: value.intervenantNom,
						prenom: value.intervenantPrenom,
						nomEntreprise: value.intervenantEntrepriseNom,
						raisonSociale: raisonSociale, 
						idEntreprise: value.intervenantEntrepriseId,
						fonction: value.fonction,
						hasSigned: this.isDuplicateMode ? false : value.hasSigned,
						hasSignedEnvelope: this.isDuplicateMode ? false : value.hasSignedEnvelope,
						email: value.email,
						sentToDocusign: this.isDuplicateMode ? false : value.sentToDocusign,
						emailStyle: '',
						envelopeId: this.isDuplicateMode ? '' : value.docusignEnvelopeId ? value.docusignEnvelopeId.toString() : '',
						envelopeIndex: -1,
						nature: '',
						isIntervenant: this.signataires.data.some( intervenant => intervenant.id === value.intervenantId ),
						updatable: true,
						docusignRecipientId: ''
					});
				}
			});
			this.representants = new MatTableDataSource<SignatairePdpEntity>(newSource);
		}
	}
	
	extractRaisonSociale(entrepisesExterieures: EntrepriseExterieureEntity[], entrepriseId: number, entrepriseNom: string): string {
		let raisonSociale: string = '';
		let entrepriseExterieur = entrepisesExterieures.find( ee => ee.idEntrepriseExt === entrepriseId );
		if (entrepriseExterieur) {
			raisonSociale = entrepriseExterieur.raisonSociale;
		} else {
			raisonSociale = this.entrepriseUtilisatrice.raisonSociale ? this.entrepriseUtilisatrice.raisonSociale : entrepriseNom;
		}
		return raisonSociale;
	}
	
	valideurSignatairesApplicable() : boolean {
		return this.versionTechnique >= applicationConstants.versionInWhichValideursCanSignPdps && this.typePdp === 0;
	}

	addValideurPdp = () => {
		this.idValideur = this.idValideur + 1;
		if (this.valideurSignatairesApplicable()) {
			this.valideurSignataires.push({
				id: this.idValideur,
				planPreventionId: this.idPdp,
				intervenantId: -1,
				intervenantEntrepriseId: -1,
				intervenantEntrepriseNom: '',
				sentToDocusign: false,
				docusignEnvelopeId: -1,
				raisonSociale: '',
				hasSigned: false,
				fonction: '',
				dateSignature: '',
				hasSignedEnvelope: false,
				docusignRecipientId: '',
				cadreEmploi: '',
				updatable: true,
				dateValidation: null,
				email: '',
				intervenant: false,
				typeValideur: TypeValideur.VALIDEUR,
				nom: '',
				prenom: '',
				envelopeIndex: -1,
				emailStyle: ''
			});
			this.displayableSignataires.push([ ... this.allPersonsPouvantSigner() ]);
			// moins tous ceux qui sont précédemment selectionnés
			let chosenIntervnants = this.valideurSignataires.map( $ => $.intervenantId );
			this.displayableSignataires[this.displayableSignataires.length - 1] = this.displayableSignataires[this.displayableSignataires.length - 1].filter($ => chosenIntervnants.indexOf($.id) === -1);
		} else {
			this.valideurs.push({
				id: this.idValideur,
				nomPrenomValidateur: '',
				entrepriseValidateur: new EntrepriseTLR(),
				raisonSociale: '',
				idEntrepriseExt: 0,
				fonctionValidateur: '',
				dateValidation: null,
				updatable : true
			});
		}
		this.notifyModelChange();
	}

	removeValideur(id: number, index: number) {
		if (this.valideurSignatairesApplicable()) {
			let valideurToRemove = this.valideurSignataires.find( $ => $.id == id );
			if (valideurToRemove && valideurToRemove.intervenantId) {
				this.retirerPersonneDansListeIntervenants(valideurToRemove.intervenantId);
				this.retirerPersonneDansListeRepresentants(valideurToRemove.intervenantId);
			}
			this.valideurSignataires = this.valideurSignataires.filter(vS => vS.id !== id);
		} else {
			this.valideurs = this.valideurs.filter(valideur => valideur.id !== id);
		}
		this.idValideur = this.idValideur - 1;
		this.selectedEntrepriseIds.splice(index, 1);
		this.selectedValideurs.splice(index, 1);
		this.displayableSignataires.splice(index, 1);
		this.notifyModelChange();
	}

	addNouveauRisque = () => {
		let newSource: NouveauRisqueEntity[] = this.nouveauxRisques.data;
		let newEntrepriseConcernees: EntrepriseTLR[] = [];
		let entreprisesById: Map<number, EntrepriseTLR> = new Map<number, EntrepriseTLR>();
		let availableEntreprises: EntrepriseTLR[] = [];
		let entreprisesSelected: Map<number, boolean> = new Map<number, boolean>();
		let selectedEntreprises: { entreprise: EntrepriseTLR }[] = [];
		let selectedEntreprise: any;
		this.idNouveauRisque = this.idNouveauRisque + 1;
		newSource.push({
			id: this.idNouveauRisque,
			dateApparitionNouveauRisque: null,
			causeApparition: '',
			entreprisesConcernees: newEntrepriseConcernees,
			entreprisesById: entreprisesById,
			availableEntreprises: availableEntreprises,
			entreprisesSelected: entreprisesSelected,
			selectedEntreprises: selectedEntreprises,
			selectedEntreprise: selectedEntreprise,
			raisonSociale: '',
			nouveauRisqueIdentifie: '',
			mesurePreventionProtection: '',
			eu: false,
			ee: false,
			noms: '',
			updatable: true
		});
		this.initListeEntreprisesTableauRisque(newSource[newSource.length - 1], this.entreprises);
		this.nouveauxRisques = new MatTableDataSource<NouveauRisqueEntity>(newSource);
		this.notifyModelChange();
	}

	removeNouveauRisque(id: number) {
		let newSource: NouveauRisqueEntity[] = this.nouveauxRisques.data;
		newSource = this.nouveauxRisques.data.filter(risque => risque.id !== id);
		newSource.filter(risque => risque.id >= id).forEach(risque => risque.id = -1);
		this.idNouveauRisque = this.idNouveauRisque - 1;
		this.nouveauxRisques = new MatTableDataSource<NouveauRisqueEntity>(newSource);
		this.notifyModelChange();
	}

	private initListeEntreprisesTableauRisque(value: NouveauRisqueEntity, entreprises: EntrepriseTLR[]) {
		value.entreprisesById = new Map<number, EntrepriseTLR>();
		for (let entreprise of entreprises) {
			value.entreprisesById.set(entreprise.id, entreprise);
		}
		value.availableEntreprises = [...entreprises];
		value.entreprisesSelected = new Map<number, boolean>();
		for (let entreprise of entreprises) {
			value.entreprisesSelected.set(entreprise.id, false);
		}
		value.selectedEntreprises = [];
	}

	onEntrepriseSelected(entreprise: EntrepriseTLR, element: any) {
		if (entreprise) {
			let nouveauRisqueEntity = this.nouveauxRisques.data[element.id - 1];
			nouveauRisqueEntity.entreprisesSelected.set(entreprise.id, true);
			this.updateAvailableEnteprises(nouveauRisqueEntity);
			nouveauRisqueEntity.selectedEntreprises.push({ entreprise: entreprise });
			setTimeout(() => {
				// Remettre la selection a zero
				// Il faut attendre un leger delai pour cependant que le binding mette en premier lieu la variable selectedEnreprise a jour
				// Sinon le moteur risque de ne pas comprendre qu'il y a une remise a zero a effectuer
				nouveauRisqueEntity.selectedEntreprise = null;
			}, 100);
			this.notifyModelChange();
		}
	}

	onEntrepriseDeselected(index: number, element: any) {
		let nouveauRisqueEntity = this.nouveauxRisques.data[element.id - 1];
		let entreprise = nouveauRisqueEntity.selectedEntreprises[index].entreprise;
		nouveauRisqueEntity.entreprisesSelected.set(entreprise.id, false);
		this.updateAvailableEnteprises(nouveauRisqueEntity);
		nouveauRisqueEntity.selectedEntreprises.splice(index, 1);
		this.notifyModelChange();
	}

	private updateAvailableEnteprises(nouveauRisque: NouveauRisqueEntity) {
		nouveauRisque.availableEntreprises = this.entreprises.filter(entreprise => !nouveauRisque.entreprisesSelected.get(entreprise.id));
	}

	openDialogRepresentants = () => {
		let representantsLeftColumn: SignatairePdpEntity[] = [];
		let filteredRepresentants : SignatairePdpEntity[] = this.allPersonsPouvantSigner();
		if (this.selectedEntrepriseForRepresentantDialog) {
			const nomEntreprise = this.selectedEntrepriseForRepresentantDialog.nom;
			filteredRepresentants = this.allPersonsPouvantSigner().filter(signataireExt => signataireExt.nomEntreprise === nomEntreprise);
		}
		if (this.representants.data.length === 0) {
			//tous les signataires sont dans la colonne de gauche (aucun signataire lie)
			representantsLeftColumn = filteredRepresentants;
		} else if (this.representants.data.length === filteredRepresentants.length
			&& this.representants.data.every(signataireLie => filteredRepresentants.some(signataireExt => signataireExt.id === signataireLie.id))
			&& filteredRepresentants.every(signataireExt => this.representants.data.some(signataireLie => signataireLie.id === signataireExt.id))
		) {
			//tous les signataires disponibles sont lies (colonne de droite)
			representantsLeftColumn = [];
		} else {
			//enlever de la colonne gauche les signataires lies
			representantsLeftColumn = filteredRepresentants
				.filter(signataireExt => this.representants.data.every(signataireLie => signataireLie.id !== signataireExt.id));
		}
		this.gererRepresentantsCommands.next([
			representantsLeftColumn, 
			this.representants.data.sort(
				(s1, s2) => s1.nom.localeCompare(s2.nom)
			)
		]);
	}

	openDialogIntervenants = () => {
		let intervenantsLeftColumn: SignatairePdpEntity[] = [];
		let filteredSignataire : SignatairePdpEntity[] = this.allPersonsPouvantSigner();
		if (this.selectedEntrepriseForIntervenantDialog) {
			const nomEntreprise = this.selectedEntrepriseForIntervenantDialog.nom;
			filteredSignataire = this.allPersonsPouvantSigner().filter(signataireExt => signataireExt.nomEntreprise === nomEntreprise);
		}
		if (this.signataires.data.length === 0) {
			//tous les signataires sont dans la colonne de gauche (aucun signataire lie)
			intervenantsLeftColumn = filteredSignataire;
		} else if (this.signataires.data.length === filteredSignataire.length
			&& this.signataires.data.every(signataireLie => filteredSignataire.some(signataireExt => signataireExt.id === signataireLie.id))
			&& filteredSignataire.every(signataireExt => this.signataires.data.some(signataireLie => signataireLie.id === signataireExt.id))
		) {
			//tous les signataires disponibles sont lies (colonne de droite)
			intervenantsLeftColumn = [];
		} else {
			//enlever de la colonne gauche les signataires lies
			intervenantsLeftColumn = filteredSignataire
				.filter(signataireExt => this.signataires.data.every(signataireLie => signataireLie.id !== signataireExt.id));
		}
		this.gererIntervenantsCommands.next([
			intervenantsLeftColumn, 
			this.signataires.data.sort(
				(s1, s2) => s1.nom.localeCompare(s2.nom)
			)
		]);
	}

	onRepresentantsSelected	(data: [SignatairePdpEntity[], SignatairePdpEntity[]]) {
			let representantsLies = data[1];
			let newSource: SignatairePdpEntity[] = [];
			if (representantsLies !== undefined) {
				representantsLies.forEach((value: SignatairePdpEntity) => {
					if (newSource.some($ => $.idEntreprise === value.idEntreprise)) {
						alert(value.prenom + ' '  + value.nom + ' ne sera pas marqué représentant car il y a dejà un représentant défini pour ' + value.nomEntreprise);
					} else {
						newSource.push({
							id: value.id,
							nom: value.nom,
							prenom: value.prenom,
							nomEntreprise: value.nomEntreprise,
							raisonSociale: this.getRaisonSociale(value.idEntreprise),
							idEntreprise: value.idEntreprise,
							fonction: value.fonction,
							hasSigned: value.hasSigned,
							hasSignedEnvelope: value.hasSignedEnvelope,
							email: value.email,
							sentToDocusign: value.sentToDocusign,
							emailStyle: '',
							envelopeId: value.envelopeId,
							envelopeIndex: value.envelopeIndex,
							nature: 'intervenant',
							isIntervenant: this.signataires.data.some( intervenant => intervenant.id === value.id ),
							updatable: true,
							docusignRecipientId: ''
						});
					}
				});
			}
			this.representants = new MatTableDataSource<SignatairePdpEntity>(newSource);
			// ceux qui sont marqués "representant" en haut et qui ne sont plus dans la liste des representants retenue en bas, doivent être décochée en haut
			this.valideurSignataires.filter( $ => $.typeValideur === TypeValideur.VALIDEUR_REPRESENTANT )
				.forEach( valideurSignataire => {
					if ( !this.representants.data.some( $ => $.id === valideurSignataire.intervenantId ) ) {
						// si cet intervenant n'est plus dans la liste faudra le changer en haut
						valideurSignataire.typeValideur = TypeValideur.VALIDEUR;
					}
				} );
			this.valideurSignataires.filter( $ => $.typeValideur === TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT )
				.forEach( valideurSignataire => {
					if ( !this.representants.data.some( $ => $.id === valideurSignataire.intervenantId ) ) {
						// si cet intervenant n'est plus dans la liste faudra le changer en haut
						valideurSignataire.typeValideur = TypeValideur.VALIDEUR_INTERVENANT;
					}
				} );
			// reciproquement : ceux qui ont été ajouté en bas et qui ne sont pas coché en haut doivent être cochés en haut
			this.representants.data.forEach( sig => {
				let valideur = this.valideurSignataires.find(v => v.intervenantId === sig.id);
				if (valideur) {
					if (valideur.typeValideur === TypeValideur.VALIDEUR) {
						valideur.typeValideur = TypeValideur.VALIDEUR_REPRESENTANT;
					} else if (valideur.typeValideur === TypeValideur.VALIDEUR_INTERVENANT) {
						valideur.typeValideur = TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT;
					}
				}
			} );
			this.notifyModelChange();
	}
	
	onIntervenantsSelected(data: [SignatairePdpEntity[], SignatairePdpEntity[]]) {
		let intervenantsLies = data[1];
		let newSource: SignatairePdpEntity[] = [];
		if (intervenantsLies !== undefined) {
			intervenantsLies.forEach((value: SignatairePdpEntity) => {
				newSource.push({
					id: value.id,
					nom: value.nom,
					prenom: value.prenom,
					nomEntreprise: value.nomEntreprise,
					raisonSociale: this.getRaisonSociale(value.idEntreprise),
					idEntreprise: value.idEntreprise,
					fonction: value.fonction,
					hasSigned: value.hasSigned,
					hasSignedEnvelope: value.hasSignedEnvelope,
					email: value.email,
					sentToDocusign: value.sentToDocusign,
					emailStyle: '',
					envelopeId: value.envelopeId,
					envelopeIndex: value.envelopeIndex,
					nature: 'intervenant',
					isIntervenant: true,
					updatable: true,
					docusignRecipientId: ''
				});
			});
		}
		this.signataires = new MatTableDataSource<SignatairePdpEntity>(newSource);
		if (this.valideurSignatairesApplicable()) {
			// ceux qui sont marqués "intervenant" en haut et qui ne sont plus dans la liste des intervenants retenue en bas, doivent être décochée en haut
			this.valideurSignataires.filter( $ => $.typeValideur === TypeValideur.VALIDEUR_INTERVENANT )
				.forEach( valideurSignataire => {
					if ( !this.signataires.data.some( $ => $.id === valideurSignataire.intervenantId ) ) {
						// si cet intervenant n'est plus dans la liste faudra le changer en haut
						valideurSignataire.typeValideur = TypeValideur.VALIDEUR;
					}
				} );
			this.valideurSignataires.filter( $ => $.typeValideur === TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT )
				.forEach( valideurSignataire => {
					if ( !this.signataires.data.some( $ => $.id === valideurSignataire.intervenantId ) ) {
						// si cet intervenant n'est plus dans la liste faudra le changer en haut
						valideurSignataire.typeValideur = TypeValideur.VALIDEUR_REPRESENTANT;
					}
				} );
			// reciproquement : ceux qui ont été ajouté en bas et qui ne sont pas coché en haut doivent être cochés en haut
			this.signataires.data.forEach( sig => {
				let valideur = this.valideurSignataires.find(v => v.intervenantId === sig.id);
				if (valideur) {
					if (valideur.typeValideur === TypeValideur.VALIDEUR) {
						valideur.typeValideur = TypeValideur.VALIDEUR_INTERVENANT;
					} else if (valideur.typeValideur === TypeValideur.VALIDEUR_REPRESENTANT) {
						valideur.typeValideur = TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT;
					}
				}
			} );
		}
		// mettre la liste des representants en accord avec cette nouvelle liste d'intervenants
		let newRepSource: SignatairePdpEntity[] = [];
		this.representants.data.forEach( rep => {
			rep.isIntervenant = this.signataires.data.some( intervenant => intervenant.id === rep.id )
			newRepSource.push(rep);
		} );
		this.representants = new MatTableDataSource<SignatairePdpEntity>(newRepSource);
		
		this.notifyModelChange();
	}

	getPdpMode() {
		if (this.planPrevention) {
			if (this.planPrevention.mode === 'update') {
				this.isUpdateMode = true;
				this.isDuplicateMode = false;
			} else if (this.planPrevention.mode === 'duplicate') {
				this.isUpdateMode = false;
				this.isDuplicateMode = true;
				
			}
		}
	}
	
	onValideurSelected(valideur: SignatairePdpEntity, index: number) {
		if (valideur) {
			this.valideurSignataires[index].intervenantId = valideur.id;
			this.valideurSignataires[index].intervenantEntrepriseId = valideur.idEntreprise;
			this.valideurSignataires[index].fonction = valideur.fonction;
			const ee = this.entreprisesExterieures.get(valideur.idEntreprise);
			this.valideurSignataires[index].raisonSociale = ee ? ee.raisonSociale : this.entrepriseUtilisatrice.raisonSociale;
			this.valideurSignataires[index].email = valideur.email;
			this.valideurSignataires[index].typeValideur = TypeValideur.VALIDEUR;
			// supprimer cet intervenant s'il existe dans la liste des intervenants en bas de page
			if (this.signataires.data.some($ => $.id === valideur.id)) {
				// faut retirer l'intervenant dans la liste des intervenants en bas de la page
				let newSource: SignatairePdpEntity[] = this.signataires.data.filter(_ => false); // forcer à false pour avoir une liste vide
				this.signataires.data.forEach((value: SignatairePdpEntity) => {
					if (value.id !== valideur.id) {
						newSource.push({
							id: value.id,
							nom: value.nom,
							prenom: value.prenom,
							nomEntreprise: value.nomEntreprise,
							raisonSociale: value.raisonSociale,
							idEntreprise: value.idEntreprise,
							fonction: value.fonction,
							hasSigned: value.hasSigned,
							hasSignedEnvelope: value.hasSignedEnvelope,
							email: value.email,
							sentToDocusign: value.sentToDocusign,
							emailStyle: value.emailStyle,
							envelopeId: value.envelopeId,
							envelopeIndex: value.envelopeIndex,
							nature: value.nature,
							isIntervenant: false,
							updatable: true,
							docusignRecipientId: ''
						});
					}
				});
				this.signataires = new MatTableDataSource<SignatairePdpEntity>(newSource);
			}
			this.selectedValideurs[index] = valideur;
			this.selectedEntrepriseIds[index] = valideur.idEntreprise;
			for (let dsp in this.displayableSignataires) {
				if (index !== Number(dsp) && this.valideurSignataires[index].intervenantEntrepriseId === valideur.idEntreprise) {
					this.displayableSignataires[Number(dsp)] = this.allPersonsPouvantSigner().filter($ => $.idEntreprise === valideur.idEntreprise && valideur.id !== $.id);
				}
			}
			this.notifyModelChange();
		}	
	}
	
	onSelectEntrepriseValideur(index: number) {
		this.entreprises.concat(this.entrepriseUtilisatrice).forEach( eV => {
			if (eV.id === this.selectedEntrepriseIds[index]) {
				this.valideurs[index].entrepriseValidateur = eV;
				this.valideurs[index].raisonSociale = eV.raisonSociale;
			}
		} );
		this.notifyModelChange();
	}
	
	onSelectEntrepriseValideurSignataire(index: number) {
		this.entreprises.concat(this.entrepriseUtilisatrice).forEach( eV => {
			if (eV.id === this.selectedEntrepriseIds[index]) {
				this.selectedValideurs[index] = new SignatairePdpEntity(); // vider le valideur pour eviter des incoherences
				this.selectedValideurs[index].nom = ''; // vider le valideur pour eviter des incoherences
				this.selectedValideurs[index].id = -1; // vider le valideur pour eviter des incoherences
				this.selectedValideurs[index].idEntreprise = eV.id; // vider le valideur pour eviter des incoherences
				this.valideurSignataires[index].intervenantEntrepriseId = eV.id;
				const ee = this.entreprisesExterieures.get(eV.id);
				this.valideurSignataires[index].raisonSociale = ee ? ee.raisonSociale : this.entrepriseUtilisatrice.raisonSociale;
				let chosenIntervenantsForThisEntreprise = this.selectedValideurs.filter( $ => $.idEntreprise === eV.id ).map( $ => $.id );
				this.displayableSignataires[index] = this.allPersonsPouvantSigner().filter( $ => $.idEntreprise === eV.id && chosenIntervenantsForThisEntreprise.indexOf($.id) === -1 );
			}
		} );
		this.onValideurSelected(this.selectedValideurs[index], index); // vider le valideur pour eviter des incoherences
		this.notifyModelChange();
	}
	
	removeValidateursForEntreprise(entrepriseId: number) {
		this.valideurs = this.valideurs.filter( v => v.entrepriseValidateur.id != entrepriseId );
		this.valideurSignataires = this.valideurSignataires.filter( v => v.intervenantEntrepriseId != entrepriseId );
	}
	
	libelleColonneValideur(): string {
		if (this.valideurSignatairesApplicable()) {
			return "Représentant / Intervenant ?";
		}
		return "Date de validation";
	}

	insererPersonneDansListeRepresentants(intervenant: SignatairePdpEntity): boolean {
		if (intervenant) {
			let representant = this.representants.data.find($ => $.id === intervenant.id);
			if (representant) {
				representant.isIntervenant = intervenant.isIntervenant;
				return true;
			} else {
				if (this.representants.data.some( $ => $.idEntreprise === intervenant.idEntreprise )) {
					// un autre representant est deja definit pour cette entreprise
					alert(intervenant.prenom + ' '  + intervenant.nom + ' ne sera pas marqué représentant car il y a dejà un représentant défini pour ' + intervenant.nomEntreprise);
					console.log(intervenant.prenom + ' '  + intervenant.nom + ' ne sera pas marqué représentant car il y a dejà un représentant défini pour ' + intervenant.nomEntreprise);
					return false;
				} else {
					let newSource: SignatairePdpEntity[] = [ ... this.representants.data ];
					newSource.push({
						id: intervenant.id,
						nom: intervenant.nom,
						prenom: intervenant.prenom,
						nomEntreprise: intervenant.nomEntreprise,
						raisonSociale: intervenant.raisonSociale,
						idEntreprise: intervenant.idEntreprise,
						fonction: intervenant.fonction,
						hasSigned: intervenant.hasSigned,
						hasSignedEnvelope: intervenant.hasSignedEnvelope,
						email: intervenant.email,
						sentToDocusign: intervenant.sentToDocusign,
						emailStyle: '',
						envelopeId: intervenant.envelopeId,
						envelopeIndex: intervenant.envelopeIndex,
						nature: intervenant.nature,
						isIntervenant: intervenant.isIntervenant,
						updatable: true,
						docusignRecipientId: ''
					});
					this.representants = new MatTableDataSource<SignatairePdpEntity>(newSource);
					return true;
				}
			}
		}
		return true;
	}
	
	insererPersonneDansListeIntervenants(intervenant: SignatairePdpEntity) {
		if (intervenant) {
			let signataire = this.signataires.data.find($ => $.id === intervenant.id);
			if (signataire) {
				signataire.isIntervenant = intervenant.isIntervenant;
			} else {
				let newSource: SignatairePdpEntity[] = [ ... this.signataires.data ];
				newSource.push({
					id: intervenant.id,
					nom: intervenant.nom,
					prenom: intervenant.prenom,
					nomEntreprise: intervenant.nomEntreprise,
					raisonSociale: intervenant.raisonSociale,
					idEntreprise: intervenant.idEntreprise,
					fonction: intervenant.fonction,
					hasSigned: intervenant.hasSigned,
					hasSignedEnvelope: intervenant.hasSignedEnvelope,
					email: intervenant.email,
					sentToDocusign: intervenant.sentToDocusign,
					emailStyle: '',
					envelopeId: intervenant.envelopeId,
					envelopeIndex: intervenant.envelopeIndex,
					nature: intervenant.nature,
					isIntervenant: true,
					updatable: true,
					docusignRecipientId: ''
				});
				this.signataires = new MatTableDataSource<SignatairePdpEntity>(newSource);
			}
		}
	}
	
	retirerPersonneDansListeIntervenants(idPersonne: number) {
		if (this.signataires.data.some($ => $.id === idPersonne)) {
			let newSource: SignatairePdpEntity[] = [];
			this.signataires.data.forEach((value: SignatairePdpEntity) => {
				if (value.id !== idPersonne) {
					newSource.push({
						id: value.id,
						nom: value.nom,
						prenom: value.prenom,
						nomEntreprise: value.nomEntreprise,
						raisonSociale: value.raisonSociale,
						idEntreprise: value.idEntreprise,
						fonction: value.fonction,
						hasSigned: value.hasSigned,
						hasSignedEnvelope: value.hasSignedEnvelope,
						email: value.email,
						sentToDocusign: value.sentToDocusign,
						emailStyle: value.emailStyle,
						envelopeId: value.envelopeId,
						envelopeIndex: value.envelopeIndex,
						nature: value.nature,
						isIntervenant: value.isIntervenant,
						updatable: true,
						docusignRecipientId: ''
					});
				}
			});
			this.signataires = new MatTableDataSource<SignatairePdpEntity>(newSource);
		}
	}
	
	retirerPersonneDansListeRepresentants(idPersonne: number) {
			if (this.representants.data.some($ => $.id === idPersonne)) {
				let newSource: SignatairePdpEntity[] = [];
				this.representants.data.forEach((value: SignatairePdpEntity) => {
					if (value.id !== idPersonne) {
						newSource.push({
							id: value.id,
							nom: value.nom,
							prenom: value.prenom,
							nomEntreprise: value.nomEntreprise,
							raisonSociale: value.raisonSociale,
							idEntreprise: value.idEntreprise,
							fonction: value.fonction,
							hasSigned: value.hasSigned,
							hasSignedEnvelope: value.hasSignedEnvelope,
							email: value.email,
							sentToDocusign: value.sentToDocusign,
							emailStyle: value.emailStyle,
							envelopeId: value.envelopeId,
							envelopeIndex: value.envelopeIndex,
							nature: value.nature,
							isIntervenant: value.isIntervenant,
							updatable: true,
							docusignRecipientId: ''
						});
					}
				});
				this.representants = new MatTableDataSource<SignatairePdpEntity>(newSource);
			}
		}
	
	onChangeTypeValideur(intervenant: SignatairePdpEntity, valideur: ValideurSignataireEntity, index: number) {

		switch (valideur.typeValideur) {
			case TypeValideur.VALIDEUR_INTERVENANT:
				// ce valideur est devenu intervenant
				this.insererPersonneDansListeIntervenants(intervenant);
				// il n'est plus representant
				this.retirerPersonneDansListeRepresentants(valideur.intervenantId);
				break;
			case TypeValideur.VALIDEUR_REPRESENTANT:
				// ce valideur est devenu representant
				intervenant.isIntervenant = false;
				if (!this.insererPersonneDansListeRepresentants(intervenant)) {
					console.log('remise du type valideur à ', TypeValideur.VALIDEUR);
					setTimeout(
						() => this.valideurSignataires[index].typeValideur = TypeValideur.VALIDEUR,
						300
					);
				}
				// ce valideur n'est plus intervenant
				this.retirerPersonneDansListeIntervenants(valideur.intervenantId);
				break;
			case TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT:
				// ce valideur est devenu intervenant et representant
				this.insererPersonneDansListeIntervenants(intervenant);
				intervenant.isIntervenant = true;
				if (!this.insererPersonneDansListeRepresentants(intervenant)) {
					console.log('remise du type valideur à ', TypeValideur.VALIDEUR_INTERVENANT);
					setTimeout(
						() => this.valideurSignataires[index].typeValideur = TypeValideur.VALIDEUR_INTERVENANT,
						300
					);
				}
				break;
			default:
				// cas on a choisit l'option VALIDEUR
				// ce valideur n'est donc plus representant
				this.retirerPersonneDansListeRepresentants(valideur.intervenantId);
				// ce valideur n'est donc plus intervenant
				this.retirerPersonneDansListeIntervenants(valideur.intervenantId);			
		}

//		// parcourir la liste des representants
//		// si un representant n'est plus dans la la liste des valideurs 
//		// faudra le retirer dans la liste des representant 
//		let newSource: SignatairePdpEntity[] = [];
//		this.representants.data.forEach( (representant: SignatairePdpEntity) => {
//			if ( this.valideurSignataires.findIndex( $ => $.intervenantId === representant.id ) > -1 ) {
//				newSource.push(representant);
//			}
//		} );
//		this.representants = new MatTableDataSource<SignatairePdpEntity>(newSource);
//		
//		// parcourir la liste des signataires
//		// si un signataire n'est plus dans la la liste des valideurs 
//		// faudra le retirer dans la liste des signataires 
//		newSource = [];
//		this.signataires.data.forEach( (signataire: SignatairePdpEntity) => {
//			if ( this.valideurSignataires.findIndex( $ => $.intervenantId === signataire.id ) > -1 ) {
//				newSource.push(signataire);
//			}
//		} );
//		this.signataires = new MatTableDataSource<SignatairePdpEntity>(newSource);
		
		this.notifyModelChange();
	}
	
	notifyModelChange() {
		let model: StepFinalModel = new StepFinalModel();
		model.dateInspectionCommunePrealable = this.dateInspectionCommunePrealable;
		model.valideurSignataires = this.valideurSignataires;
		model.valideurs = this.valideurs;
		model.nouveauxRisques = this.nouveauxRisques.data;
		model.signataires = this.signataires.data;
		model.representants = this.representants.data.map($ => this.convertToRepresentant($));
		this.onModelChange.emit(model);
	}
	
	allPersonsPouvantSigner() {
		let allPersonsPouvantSigner:SignatairePdpEntity[] = [];
		this.personnesPouvantSigner.forEach(personnePouvantSigner => allPersonsPouvantSigner.push(personnePouvantSigner) );
		this.personnesPouvantSignerDansEntrepriseUtilisatrice.forEach(personnePouvantSignerDansEntrepriseUtilisatrice => {
			if (!allPersonsPouvantSigner.some( $ => $.id === personnePouvantSignerDansEntrepriseUtilisatrice.id )) {
				allPersonsPouvantSigner.push(personnePouvantSignerDansEntrepriseUtilisatrice);
			}
		} );
		allPersonsPouvantSigner.sort((s1, s2) => s1.nom.localeCompare(s2.nom));
		return allPersonsPouvantSigner;
	}

	getRaisonSociale(idEntreprise: number): string {
		if (this.entrepriseUtilisatrice.id === idEntreprise) {
			return this.entrepriseUtilisatrice.raisonSociale;
		}
		const entrepriseExterieure: EntrepriseExterieureEntity | undefined = this.entreprisesExterieures.get(idEntreprise);
		if (entrepriseExterieure) {
			return entrepriseExterieure.raisonSociale ? entrepriseExterieure.raisonSociale : entrepriseExterieure.nomEntreprise;
		}
		return '';
	}
	
	convertToRepresentant(signataire: SignatairePdpEntity): RepresentantEntity {
		let representant = new RepresentantEntity();
		representant.intervenantId = signataire.id;
		representant.email = signataire.email;
		representant.fonction = signataire.fonction;
		representant.raisonSociale = signataire.raisonSociale;
		representant.hasSigned = signataire.hasSigned;
		if (signataire.envelopeId) {
			representant.docusignEnvelopeId = Number(signataire.envelopeId);
		}
		return representant;
	}
	
	onChangeChoixIntervenant(representant: SignatairePdpEntity, index: number) {
		console.log('onChangeChoixIntervenant, representant: ', representant, ', index: ', index);
		if (representant.isIntervenant) {
			this.insererPersonneDansListeIntervenants(representant);
			// si cette personne est dans la liste des valideurs faut lui ajouter le type intervenant
			this.valideurSignataires.filter(v => v.intervenantId === representant.id).forEach( valideur => {
				switch (valideur.typeValideur) {
					case TypeValideur.VALIDEUR_REPRESENTANT:
						// ce valideur devient VALIDEUR_REPRESENTANT_INTERVENANT
						valideur.typeValideur = TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT;
						break;
					case TypeValideur.VALIDEUR:
						// ce valideur devient VALIDEUR_INTERVENANT
						valideur.typeValideur = TypeValideur.VALIDEUR_INTERVENANT;
						break;
					default:
						// rien à faire		
				}
			} );
		} else {
			this.retirerPersonneDansListeIntervenants(representant.id);
			// si cette personne est dans la liste des valideurs faut lui retirer le type intervenant
			this.valideurSignataires.filter(v => v.intervenantId === representant.id).forEach( valideur => {
				switch (valideur.typeValideur) {
					case TypeValideur.VALIDEUR_INTERVENANT:
						// ce valideur devient VALIDEUR
						valideur.typeValideur = TypeValideur.VALIDEUR;
						break;
					case TypeValideur.VALIDEUR_REPRESENTANT_INTERVENANT:
						// ce valideur devient VALIDEUR_REPRESENTANT
						valideur.typeValideur = TypeValideur.VALIDEUR_REPRESENTANT;
						break;
					default:
						// rien à faire		
				}
			} );
		}
		this.notifyModelChange();
	}
	
	majValideurEmailInOtherListes(valideur: ValideurSignataireEntity) {

		let newRepSource:SignatairePdpEntity[] = [];
		this.representants.data.forEach( $ => {
			if (valideur.intervenantId === $.id) {
				$.email = valideur.email;
				$.emailStyle = valideur.emailStyle;
			}
			newRepSource.push($);
		} );
		this.representants = new MatTableDataSource<SignatairePdpEntity>(newRepSource);

		let newIntSource:SignatairePdpEntity[] = [];
		this.signataires.data.forEach( $ => {
			if (valideur.intervenantId === $.id) {
				$.email = valideur.email;
				$.emailStyle = valideur.emailStyle;
			}
			newIntSource.push($);
		} );
		this.signataires = new MatTableDataSource<SignatairePdpEntity>(newIntSource);

	}
	
	majRepresentantEmailInOtherListes(representant: SignatairePdpEntity) {

		let newIntSource:SignatairePdpEntity[] = [];
		this.signataires.data.forEach( $ => {
			if (representant.id === $.id) {
				$.email = representant.email;
				$.emailStyle = representant.emailStyle;
			}
			newIntSource.push($);
		} );
		this.signataires = new MatTableDataSource<SignatairePdpEntity>(newIntSource);

		this.valideurSignataires.forEach( $ => {
			if (representant.id === $.intervenantId) {
				$.email = representant.email;
				$.emailStyle = representant.emailStyle;
			}
		} );

	}

	majIntervenantEmailInOtherListes(intervenant: SignatairePdpEntity) {

		let newRepSource:SignatairePdpEntity[] = [];
		this.representants.data.forEach( $ => {
			if (intervenant.id === $.id) {
				$.email = intervenant.email;
				$.emailStyle = intervenant.emailStyle;
			}
			newRepSource.push($);
		} );
		this.representants = new MatTableDataSource<SignatairePdpEntity>(newRepSource);

		this.valideurSignataires.forEach( $ => {
			if (intervenant.id === $.intervenantId) {
				$.email = intervenant.email;
				$.emailStyle = intervenant.emailStyle;
			}
		} );

	}

	onFocusLeaveEmailValideurSignataire(valideur: ValideurSignataireEntity) {
		if (valideur.email) {
			valideur.email = valideur.email.trim();
			if (!applicationConstants.emailRegexp.test(valideur.email)) {
				valideur.emailStyle = 'error';
			} else {
				valideur.emailStyle = '';
			}
		}
		// maj de l'email dans les autres listes si cette personne y figure
		this.majValideurEmailInOtherListes(valideur);
		
		this.notifyModelChange();
	}
	
	onFocusLeaveEmailRepresentant(representant: SignatairePdpEntity) {
		if (representant.email) {
			representant.email = representant.email.trim();
			if (!applicationConstants.emailRegexp.test(representant.email)) {
				representant.emailStyle = 'error';
			} else {
				representant.emailStyle = '';
			}
		}
		// maj de l'email dans les autres listes si cette personne y figure
		this.majRepresentantEmailInOtherListes(representant);

		this.notifyModelChange();
	}

	onFocusLeaveEmailIntervenant(intervenant: SignatairePdpEntity) {
		if (intervenant.email) {
			intervenant.email = intervenant.email.trim();
			if (!applicationConstants.emailRegexp.test(intervenant.email)) {
				intervenant.emailStyle = 'error';
			} else {
				intervenant.emailStyle = '';
			}
		}
		// maj de l'email dans les autres listes si cette personne y figure
		this.majIntervenantEmailInOtherListes(intervenant);

		this.notifyModelChange();
	}
	
	suggestableTypeValideurs(valideur: ValideurSignataireEntity) {
		if (this.entrepriseUtilisatrice && valideur.intervenantEntrepriseId === this.entrepriseUtilisatrice.id) {
			return applicationConstants.typeValideurs.filter( t => t.code === 'VALIDEUR' );
		}
		return applicationConstants.typeValideurs;
	}
	
}